import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20c-.87 0-20 2.609-20 2.609L0 20Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#000",
  d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20"
}, null, -1), a = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "M25 11.34a9.936 9.936 0 0 0-5-1.337v2.608a7.341 7.341 0 0 1 3.695.988c3.53 2.038 4.744 6.567 2.706 10.097a7.416 7.416 0 0 1-.604.89l-11.564-6.325a2.609 2.609 0 0 0 1.037 3.54l8.42 4.602a7.396 7.396 0 0 1-7.386-.002 7.342 7.342 0 0 1-2.47-2.33l-2.178 1.438a9.994 9.994 0 0 0 12.504 3.58c.11.095.232.18.366.254l2.288 1.251a2.174 2.174 0 0 0 2.951-.864l1.252-2.288-2.907-1.59c.195-.272.38-.556.55-.852 2.757-4.775 1.115-10.903-3.66-13.66Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "m17.258 15.907 1.695 1.23-.646 1.994 1.694-1.233 1.696 1.23-.649-1.992 1.694-1.232-2.095.001L20 13.913l-.646 1.993-2.095.001Z"
}, null, -1), d = [
  n,
  c,
  a,
  s
];
function i(_, h) {
  return t(), e("svg", o, [...d]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
